import React from 'react';

import { ClassroomNavigation } from 'Domain/Classroom';

import withConfig from '../../../../Context/ConfigContext/hoc';

import ComingSoonView from './ComingSoon.view';

const ComingSoon = ({
  appConfig: {
    uiVariant,
    classroom: { defaultOwnerLogoUrl },
  },
}) => {
  return (
    <ClassroomNavigation>
      {({ previousSubsection, nextSubsection, goToNextSubsection, goToPreviousSubsection }) => {
        return (
          <ComingSoonView
            bg={'white'}
            height={uiVariant !== 'PAAS' ? '100vh' : '100%'}
            py={5}
            px={3}
            imageUrl={defaultOwnerLogoUrl ?? '/assets/images/not_found.png'}
            onNextClick={nextSubsection && uiVariant !== 'PASS' ? goToNextSubsection : undefined}
            onPreviousClick={
              previousSubsection && uiVariant !== 'PAAS' ? goToPreviousSubsection : undefined
            }
          />
        );
      }}
    </ClassroomNavigation>
  );
};

export default withConfig(ComingSoon);
